<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
            <div class="mb-20 d-flex ">
                <!-- <el-button type="primary" @click="handleAddSectionsHeader" class="ml-auto">
                    <span class="color-white">
                        add sectionsHeader
                    </span>
                </el-button> -->
            </div>
            <el-card class="box-card">
                <el-table :data="sectionsHeaders" style="width: 100%">
                    
                    
                    
                    
                    
                    <el-table-column label="title En" >
                        <template #default="scope">
                           <h3>{{scope.row.id.split('/').join(' => ')}}</h3>
                        </template>
                    </el-table-column>
                    <el-table-column label="title En" >
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').title}}
                        </template>
                    </el-table-column>
                    <el-table-column label="description En" >
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').description}}
                        </template>
                    </el-table-column>

                    <el-table-column label="title Ar" class-name="text-right rtl">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'ar_sa').title}}
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="description Ar" class-name="text-right rtl">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'ar_sa').description}}
                        </template>
                    </el-table-column>

                    
                    <el-table-column label="Operations" width="100">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit product"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditSectionsHeader(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
export default {
    computed:{
        cachedSectionsHeaders(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.sectionsHeaders?.list || []
        },
    },
    data(){
        return{
            sectionsHeaders:[],
            sectionsHeaderStatus:[],
           
        }
    },
    async mounted(){
        if (!this.cachedSectionsHeaders?.length){
            this.getAllSectionsHeaders();
        }else{
            this.sectionsHeaders = this.cachedSectionsHeaders;
          
        }
        
       
    },
    
    methods:{
       
        async getAllSectionsHeaders(){
            const response = await this.$store.dispatch('getAllSectionsHeaders');

            this.sectionsHeaders = response;
             
        },
        async changeSectionsHeaderStatus(sectionsHeader){
            const response = await this.$store.dispatch('changeSectionsHeaderStatus',sectionsHeader.id);
            if (response.data.status == 1){
         
                this.getAllSectionsHeaders();
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
            }else{
                let currentSectionsHeaderIndex = this.sectionsHeaders.findIndex(prt => prt.id == sectionsHeader.id);
                this.sectionsHeaders[currentSectionsHeaderIndex].active = !this.sectionsHeaders[currentSectionsHeaderIndex].active 
                // this.sectionsHeaders.splice(currentSectionsHeaderIndex,1);
            }
             
        },
        async handleAddSectionsHeader(){
            this.$router.push({
                name:'manage-sections-header',
            })
           
        },
        async handleEditSectionsHeader(sectionsHeader){
            await this.$store.dispatch('storeCurrentSectionsHeaderToView',sectionsHeader)
            this.$router.push({
                name:'manage-sections-header',
                params:{
                    id:sectionsHeader.id
                }
            })
        },
      
    
       
        
    }
}
</script>
<style lang="scss">
    .text-right.rtl {
        .cell {
            text-align: right;
            direction: rtl;
        }
    }
</style>